import React from 'react';
interface LayoutPickerProps {
  sectionType: 'listings-videos' | 'custom-links';
  selectedLayout: string;
  onLayoutChange: (layout: string) => void;
}
export function LayoutPicker({
  sectionType,
  selectedLayout,
  onLayoutChange
}: LayoutPickerProps) {
  if (sectionType === 'listings-videos') {
    const layouts = [{
      id: 'carousel',
      label: 'Carousel'
    }, {
      id: 'small-card',
      label: 'Small Cards'
    }, {
      id: 'large-card',
      label: 'Large Cards'
    }];
    return <div className="mb-4" data-id="element-124">
        <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-125">
          Layout
        </label>
        <div className="flex gap-3" data-id="element-126">
          {layouts.map(layout => <button key={layout.id} type="button" onClick={() => onLayoutChange(layout.id)} className={`flex-1 p-3 rounded-xl border-2 transition-all ${selectedLayout === layout.id ? 'border-brand-forest bg-brand-sage/30' : 'border-brand-light bg-white hover:border-brand-sage'}`} data-id="element-127">
              <div className="mb-2" data-id="element-128">
                {layout.id === 'carousel' && <div className="flex gap-1 justify-center" data-id="element-129">
                    <div className="w-8 h-10 bg-brand-light rounded" data-id="element-130"></div>
                    <div className="w-8 h-10 bg-brand-muted/20 rounded" data-id="element-131"></div>
                    <div className="w-8 h-10 bg-brand-muted/10 rounded" data-id="element-132"></div>
                  </div>}
                {layout.id === 'small-card' && <div className="grid grid-cols-2 gap-1" data-id="element-133">
                    <div className="h-8 bg-brand-light rounded" data-id="element-134"></div>
                    <div className="h-8 bg-brand-light rounded" data-id="element-135"></div>
                    <div className="h-8 bg-brand-light rounded" data-id="element-136"></div>
                    <div className="h-8 bg-brand-light rounded" data-id="element-137"></div>
                  </div>}
                {layout.id === 'large-card' && <div className="space-y-1" data-id="element-138">
                    <div className="h-6 bg-brand-light rounded" data-id="element-139"></div>
                    <div className="h-6 bg-brand-light rounded" data-id="element-140"></div>
                  </div>}
              </div>
              <p className="text-xs font-medium text-brand-dark text-center" data-id="element-141">
                {layout.label}
              </p>
            </button>)}
        </div>
      </div>;
  }
  const layouts = [{
    id: 'list',
    label: 'List (1 per row)'
  }, {
    id: 'grid',
    label: 'Grid (2 per row)'
  }];
  return <div className="mb-4" data-id="element-142">
      <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-143">
        Layout
      </label>
      <div className="flex gap-3" data-id="element-144">
        {layouts.map(layout => <button key={layout.id} type="button" onClick={() => onLayoutChange(layout.id)} className={`flex-1 p-3 rounded-xl border-2 transition-all ${selectedLayout === layout.id ? 'border-brand-forest bg-brand-sage/30' : 'border-brand-light bg-white hover:border-brand-sage'}`} data-id="element-145">
            <div className="mb-2" data-id="element-146">
              {layout.id === 'list' && <div className="space-y-1" data-id="element-147">
                  <div className="h-4 bg-brand-light rounded" data-id="element-148"></div>
                  <div className="h-4 bg-brand-light rounded" data-id="element-149"></div>
                  <div className="h-4 bg-brand-light rounded" data-id="element-150"></div>
                </div>}
              {layout.id === 'grid' && <div className="grid grid-cols-2 gap-1" data-id="element-151">
                  <div className="h-6 bg-brand-light rounded" data-id="element-152"></div>
                  <div className="h-6 bg-brand-light rounded" data-id="element-153"></div>
                  <div className="h-6 bg-brand-light rounded" data-id="element-154"></div>
                  <div className="h-6 bg-brand-light rounded" data-id="element-155"></div>
                </div>}
            </div>
            <p className="text-xs font-medium text-brand-dark text-center" data-id="element-156">
              {layout.label}
            </p>
          </button>)}
      </div>
    </div>;
}